(function (angular) {

    angular
        .module('repairforms.constant.module')
        .constant('REST_URL', RestUrl());

    function RestUrl() {
        return {
            PRODUCT: {
                PRODUCT_DATA: 'product/data'
            },
            SITE: {
                IS_FOOTLESS: 'isFootless',
                IS_HEADLESS: 'isHeadless',
                IS_MOBILE: 'isMobile',
                COUNTRY: 'checkCountry',
                LANGUAGE: 'checkLanguage',
                HOST: 'external/host'
            },
            SUBMIT_FORM_DATA: 'request/submit',
            CALENDAR: {
                HOLIDAYS: 'resource/holidays'
            },
            COURIER: {
                STORES: 'shipment/find'
            }
        }
    }
})(angular);